// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".q19sQoO9fcqq6NfI5FZ6 {\n\tpadding-right: 32px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/estimates/details/components/styles/PortsModal.module.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB","sourcesContent":[".title {\n\tpadding-right: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "q19sQoO9fcqq6NfI5FZ6"
};
export default ___CSS_LOADER_EXPORT___;
